import { render, staticRenderFns } from "./ReportColorsWithSizes.vue?vue&type=template&id=eeb78004"
import script from "./ReportColorsWithSizes.vue?vue&type=script&lang=js"
export * from "./ReportColorsWithSizes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports